import * as Styled from "./style";
import { Outlet } from "react-router";
import { checkEntraAuthGate } from "@/utils/statsig";

export const AuthLayout = () => {
  const isUsingB2CAuth = checkEntraAuthGate();

  if (isUsingB2CAuth) {
    return (
      <Styled.EntraContainer>
        <Styled.EntraImageBlock />
        <Styled.EntraInfoBlock>
          <Styled.FormContainer>
            <Outlet />
          </Styled.FormContainer>
        </Styled.EntraInfoBlock>
      </Styled.EntraContainer>
    );
  }

  return (
    <Styled.Container>
      <Styled.ImageBlock />
      <Styled.InfoBlock>
        <Styled.FormContainer>
          <Outlet />
        </Styled.FormContainer>
      </Styled.InfoBlock>
    </Styled.Container>
  );
};

export default AuthLayout;
